import styled from '@emotion/styled';
import {colors} from 'ui/config';
import {Img} from 'ui';
// import {Link} from 'react-router-dom';

export const Image = styled(Img)({
  width: 334,
  height: 261,
  backgroundSize: 'cover',
});

export const ArticleTeaser = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  textDecoration: 'none',
  width: 334,
  maxWidth: 334,
  // paddingLeft: 20,
  // paddingRight: 20,
  marginBottom: 20,
  marginRight: 0,
});

export const ArticleTitle = styled('div')({
  display: 'flex',
  padding: '13px 20px',
  height: 70,
  width: 334,
  backgroundColor: colors.white,
});
